import React, { useState } from 'react';
import axios from 'axios';
import './Auth.css';

const API_URL = '/api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setToken(null);
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/auth/request-reset`, { email });
      setMessage('Si le compte existe, un email de réinitialisation a été envoyé.');
      // pour dev: afficher le token renvoyé
      if (res.data?.token) setToken(res.data.token);
    } catch (err) {
      setMessage(err.response?.data?.message || 'Erreur lors de la demande');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Réinitialiser le mot de passe</h1>
          <p>Entrez l'email lié à votre compte pour recevoir un lien de réinitialisation.</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {message && <div className="auth-error">{message}</div>}

          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="votre@email.com" required />
          </div>

          <button type="submit" className="btn-auth" disabled={loading}>
            {loading ? 'Envoi...' : 'Envoyer le lien'}
          </button>
        </form>

        {token && (
          <div style={{ marginTop: 12 }}>
            <p style={{ fontSize: 13 }}>Token (dev only) :</p>
            <code style={{ wordBreak: 'break-all' }}>{token}</code>
            <p style={{ marginTop: 8 }}>Utilisez ce token sur la page de réinitialisation.</p>
          </div>
        )}
      </div>
    </div>
  );
}
